/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  Dispatch,
  FC,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from "react";

import classnames from "classnames";
import { Link, PageProps } from "gatsby";

import Button from "@components/common/Button";
import Icon from "@components/common/Icon";

import { gaSelectItem, gaViewItemList } from "@analytics/google";
import getItems from "@helpers/items/getItems";

const ProductDropDownMenu: FC<{
  toggleMenu: (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement | HTMLAnchorElement>) => void;
  isActive: boolean;
  setIsActive: Dispatch<SetStateAction<boolean>>;
  location: PageProps["location"];
}> = ({ toggleMenu, isActive, setIsActive, location }) => {
  const prevPathRef = useRef(location?.pathname);

  const items = useMemo(() => getItems(), []);

  useEffect(() => {
    if (location?.pathname !== prevPathRef.current) {
      setIsActive(false);
      prevPathRef.current = location?.pathname;
    }
  }, [location?.pathname, setIsActive]);

  // useEffect(() => {
  //   gaViewItemList({ products: orderedProducts }); // TEMP SOLUTION | REMOVE COMMENT AFTER COMMIT
  // }, []);

  const toggleActive = useCallback((): void => {
    setIsActive(!isActive);
  }, [isActive, setIsActive]);

  const onMouseEnter = (): void => {
    setIsActive(true);
  };

  return (
    <div
      className={classnames("products-items", { "is-active": isActive })}
      onMouseEnter={onMouseEnter}
    >
      <Button
        icon="chevron"
        color="transparent"
        className={classnames("products-drop-down", { "is-active": isActive })}
        iconClassName={classnames("button-icon", { "is-active": isActive })}
        onClick={toggleActive}
      >
        Supplements
      </Button>

      <div
        className={classnames("products-body", { "is-active": isActive })}
        style={{
          paddingTop: "12px",
        }}
      >
        <div className="body-wrapper">
          <Button
            icon="chevron"
            color="transparent"
            className={classnames("products-drop-down", { "is-active": isActive })}
            onClick={toggleActive}
            iconClassName={classnames("button-icon", { "is-active": isActive })}
          >
            Supplements
          </Button>
          <div className="product-cards" onClick={toggleMenu}>
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/shop/${item.information?.slug}`}
                onClick={() => {
                  gaSelectItem(item);
                }}
                className="product-card-header"
              >
                <div className="image-container">
                  <img
                    alt={`${item.name} - Medipups`}
                    src={item.information?.images.main}
                    width={180}
                    height={180}
                    loading="eager"
                  />
                </div>
                <div className="product-description">
                  {item.information?.secondName && (
                    <div className="title text">{item.information.secondName}</div>
                  )}
                  <span className="description">{item.description}</span>
                </div>
              </Link>
            ))}
          </div>

          <Link to="/shop" className="all-products-link" onClick={toggleMenu}>
            See all supplements <Icon name="chevron" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductDropDownMenu;
